import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sainik-registration',
  templateUrl: './sainik-registration.component.html',
  styleUrls: ['./sainik-registration.component.css']
})
export class SainikRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/sainik-registration.component.ts